import cn from 'classnames';
import * as React from 'react';

export const CreationLoader = ({ className }: { className?: string }): JSX.Element => {
  return (
    <div className={cn({ 'flex bg-gray-100': true, [className || '']: !!className })}>
      <div className="w-160 border-r"></div>

      <svg
        role="img"
        width="476"
        height="124"
        className="p-24"
        aria-labelledby="loading-aria"
        viewBox="0 0 476 124"
        preserveAspectRatio="none"
      >
        <title id="loading-aria">Loading...</title>
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          clipPath="url(#clip-path)"
          style={{ fill: 'url("#fill")' }}
        ></rect>
        <defs>
          <clipPath id="clip-path">
            <rect x="6" y="5" rx="8" ry="8" width="186" height="25" />
            <rect x="197" y="5" rx="8" ry="8" width="67" height="25" />
            <rect x="10" y="35" rx="4" ry="4" width="129" height="7" />
            <rect x="5" y="106" rx="8" ry="8" width="100" height="14" />
            <rect x="110" y="105" rx="8" ry="8" width="42" height="15" />
          </clipPath>
          <linearGradient id="fill">
            <stop offset="0.599964" stopColor="#eceff2" stopOpacity="1">
              <animate
                attributeName="offset"
                values="-2; -2; 1"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              ></animate>
            </stop>
            <stop offset="1.59996" stopColor="#ecebeb" stopOpacity="1">
              <animate
                attributeName="offset"
                values="-1; -1; 2"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              ></animate>
            </stop>
            <stop offset="2.59996" stopColor="#eceff2" stopOpacity="1">
              <animate
                attributeName="offset"
                values="0; 0; 3"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              ></animate>
            </stop>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
